import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { styled, Tooltip, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    padding: '20px 10px',
    borderBottom: '1px solid lightgray',
  },
  flexWrap: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  badge: {
    background: '#EFF2FC',
    color: '#363636',
    borderRadius: '5px',
    fontWeight: 'bold',
    padding: '2px 5px',
    textTransform: 'uppercase',
    fontSize: '12px',
    marginRight: '10px',
    marginBottom: '10px',
  },
});

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    interactive
    enterDelay={100}
    leaveDelay={100}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#fff',
    color: '#000',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    border: '1px solid #ccc',
    maxHeight: '300px',
    overflow: 'auto',
  },
}));

export default function AssigneeInfo({ assigneeInfo }) {
  const classes = useStyles();
  return (
    <div>
      {assigneeInfo?.data?.length > 0 && (
        <div className={classes.container}>
          <Typography
            variant="body2"
            style={{ fontWeight: 'bold' }}
            gutterBottom
          >
            Assignee
          </Typography>
          <div className={classes.flexWrap}>
            {assigneeInfo?.data?.map(item => (
              <span className={classes.badge} key={item?.assignee_name}>
                {item?.assignee_name}{' '}
                {item?.branches?.length > 1 ? (
                  <CustomTooltip
                    title={
                      <div>
                        {item?.branches?.slice(1)?.map((branch, index) => (
                          <div key={branch}>
                            {branch}
                            {index < item?.branches?.length - 2 && (
                              <hr
                                style={{
                                  margin: '4px 0',
                                  borderColor: '#ccc',
                                  borderStyle: 'solid',
                                }}
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <span>
                      ( {item?.branches?.[0]}
                      {item?.branches?.length > 1 &&
                        ` +${item?.branches?.length - 1} more`}{' '}
                      )
                    </span>
                  </CustomTooltip>
                ) : (
                  item?.branches?.length > 0 && `( ${item.branches[0]} )`
                )}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
